import * as React from "react";

export type LinkButtonProps = React.DetailedHTMLProps<
  React.AnchorHTMLAttributes<HTMLAnchorElement>,
  HTMLAnchorElement
>;

export const LinkButton: React.FC<LinkButtonProps> = ({
  children,
  ...props
}) => {
  // eslint-disable-next-line
  return <a {...props}>{children}</a>;
};
